import { Env } from './env';

export const environment: Env = {
  appVersion: require('package.json').version,
  production: false,
  apiServer: 'https://supplierportal.uat.abcis.com.au/supplier-api',
  authenticationServer: 'https://auth.uat.abcis.com.au',
  clientCredentials: 'supplier-portal-web-ui:En2cBbj55Xvw6djg'
};
